export default {
    when() {
        return document.querySelectorAll('.header-navigation').length > 0;
    },

    mounted() {
        var new_scroll_position = 0;
        var last_scroll_position;
        var headerNavigationHide = document.querySelector('.header-navigation');
        let headerMobile = document.querySelector('.main-nav-mobile');
        let bannerTop = document.querySelector('#banner-top');
        headerMobile.style.height = "calc(100vh - 114px)"
        window.addEventListener(
            'scroll',
            function (e) {
                last_scroll_position = window.scrollY;
                // Scrolling down
                if (
                    new_scroll_position < last_scroll_position &&
                    last_scroll_position > 80
                ) {
                    headerNavigationHide.classList.remove('slideDown');
                    headerNavigationHide.classList.add('slideUp');
                    headerNavigationHide.style.transform = 'translateY(-144px)';
                    // Scrolling up
                } else {
                    if (last_scroll_position > 80) {
                        headerNavigationHide.style.transform =
                            'translateY(0px)';
                    } else {
                        headerNavigationHide.style.transform =
                            'translateY(0px)';
                    }
                    headerNavigationHide.classList.remove('slideUp');
                    headerNavigationHide.classList.add('slideDown');
                }

                new_scroll_position = last_scroll_position;

                if (new_scroll_position > 80) {
                    headerMobile.style.height = "calc(100vh - 74px)"
                } else {
                    headerMobile.style.height = "calc(100vh - 114px)"
                }
            },
            { passive: true }
        );

        let hamburgerOpen = document.querySelector('#hamburger-open');
        let hamburgerClose = document.querySelector('#hamburger-close');
        let navMobile = document.querySelector('.main-nav-mobile');
        let headerNavigation = document.querySelector('.header-navigation');
        hamburgerOpen.addEventListener(
            'click',
            () => {
                hamburgerOpen.classList.toggle('hidden');
                hamburgerClose.classList.toggle('hidden');
                hamburgerClose.classList.toggle('flex');
                navMobile.classList.toggle('nav-active');
                navMobile.classList.toggle('animate-slide-in-bck-center');
                document.body.classList.toggle('overflow-y-hidden');
                headerNavigation.classList.toggle('header-active');
            },
            { passive: true },
            false
        );
        hamburgerClose.addEventListener(
            'click',
            () => {
                hamburgerOpen.classList.toggle('hidden');
                hamburgerClose.classList.toggle('hidden');
                hamburgerClose.classList.toggle('flex');
                navMobile.classList.toggle('nav-active');
                navMobile.classList.toggle('animate-slide-in-bck-center');
                document.body.classList.toggle('overflow-y-hidden');
                headerNavigation.classList.toggle('header-active');
            },
            { passive: true },
            false
        );
    },
};
